import './radioCard.scss';

import { forwardRef, ReactNode, useState } from 'react';

import { RadioCardProps } from '../RadioCardGroup/types/RadioCardProps';

export const RadioCard = forwardRef<HTMLInputElement, RadioCardProps>(
  ({ title, subtitle, image, loading, ...props }, ref): ReactNode => {
    const [imageLoaded, setImageLoaded] = useState(false);

    const rootClassName = [
      'radio-card',
      props.checked && 'radio-selected',
      loading && 'loading',
      props.className,
    ]
      .filter(Boolean)
      .join(' ');

    const titleClassName = [
      'radio-card-title',
      loading && 'skeleton-loading-sweep',
    ]
      .filter(Boolean)
      .join(' ');

    const subtitleClassName = [
      'radio-card-subtitle',
      loading && 'skeleton-loading-sweep',
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <label className={rootClassName}>
        <div>
          {(loading || (image && !imageLoaded)) && (
            <div className="image-loading skeleton-loading-sweep" />
          )}
          {!loading && image && (
            <img
              alt={title}
              className={!imageLoaded ? 'hidden' : undefined}
              src={image}
              onLoad={(): void => {
                setImageLoaded(true);
              }}
            />
          )}
          <div>
            <span className={titleClassName}>{title}</span>
            <span className={subtitleClassName}>{subtitle}</span>
          </div>
        </div>
        <div>
          <input
            {...props}
            disabled={loading}
            ref={ref}
            role="radio"
            type="radio"
          />
          <span />
        </div>
      </label>
    );
  },
);
